function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { MAX_SESSION_TIME_IN_SECONDS } from '@engine/constants';
import { connect } from 'react-redux';
import { decrementSessionTimer } from '@engine/actions/creators/session-time';
var DANGER_WIDTH = 20;
var WARNING_WIDTH = 50;
var MAX_WIDTH = 110;
var DANGER_CLASS = 'danger';
var WARNING_CLASS = 'warning';

var SessionTimer = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionTimer, _React$Component);

  var _super = _createSuper(SessionTimer);

  function SessionTimer(props) {
    var _this;

    _classCallCheck(this, SessionTimer);

    _this = _super.call(this, props);
    _this.decrementSessionTimer = _this.props.decrementSessionTimer.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Component life cycle
   */


  _createClass(SessionTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTicking();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTicking();
    }
    /**
     * Private methods
     */

  }, {
    key: "startTicking",
    value: function startTicking() {
      this.interval = setInterval(this.decrementSessionTimer, moment.duration(1, 'second').asMilliseconds());
    }
  }, {
    key: "stopTicking",
    value: function stopTicking() {
      clearInterval(this.interval);
    }
  }, {
    key: "formatDigits",
    value: function formatDigits(number) {
      return ('00' + number).substr(-2, 2);
    }
    /**
     * Computed properties
     */

  }, {
    key: "duration",
    get: function get() {
      return moment.duration(this.props.sessionTime, 'seconds');
    }
  }, {
    key: "minutes",
    get: function get() {
      return this.formatDigits(this.duration.minutes());
    }
  }, {
    key: "seconds",
    get: function get() {
      return this.formatDigits(this.duration.seconds());
    }
  }, {
    key: "progressWidth",
    get: function get() {
      var percent = this.props.sessionTime / MAX_SESSION_TIME_IN_SECONDS;
      return percent * MAX_WIDTH;
    }
  }, {
    key: "progressBarClass",
    get: function get() {
      if (this.progressWidth < WARNING_WIDTH && this.progressWidth > DANGER_WIDTH) {
        return WARNING_CLASS;
      }

      if (this.progressWidth < DANGER_WIDTH) {
        return DANGER_CLASS;
      }

      return '';
    }
  }, {
    key: "isExpired",
    get: function get() {
      return this.props.sessionTime === 0;
    }
    /**
     * Render component
     */

  }, {
    key: "render",
    value: function render() {
      if (this.isExpired) {
        this.stopTicking();
        return React.createElement("div", {
          className: "session-time danger"
        }, I18n.t('javascript.session_timeout'));
      }

      return React.createElement("div", {
        className: "session-time"
      }, React.createElement("span", {
        className: "minutes"
      }, this.minutes), React.createElement("span", {
        className: "split"
      }, ":"), React.createElement("span", {
        className: "seconds"
      }, this.seconds), React.createElement("div", {
        className: "session-progress"
      }, React.createElement("div", {
        className: 'session-bar ' + this.progressBarClass,
        style: {
          width: this.progressWidth + 'px'
        }
      })));
    }
  }]);

  return SessionTimer;
}(React.Component);

export default connect(function (state) {
  return {
    sessionTime: state.sessionTime
  };
}, {
  decrementSessionTimer: decrementSessionTimer
})(SessionTimer);